<template>
  <basic-container class="examinereportrectify202111121">
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page.sync="page"
               v-if="reWrite"
               :permission="permissionList"
               v-model="form"
               :search.sync="search"
               ref="crud"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="onLoad"
               @on-load="onLoad">
      <template slot="menuLeft">
        <Form ref="form" @onLoad="onLoad" :projectId="search.projectId"></Form>
      </template>
      <template slot="menu" scope="scope">
                <el-button 
                          type="text"
                          size="small"
                          @click="handleOpenFormDialog(scope.row,'view')">查 看

                </el-button>
                <el-button 
                          type="text"
                          size="small"
                          @click="handleOpenFormDialog(scope.row,'edit')">编 辑

                </el-button>
                <el-button 
                          type="text"
                          size="small"
                          @click="rowDel(scope.row)">删 除
                </el-button>
                <el-button 
                          type="text"
                          size="small"
                          @click="openPrintDialog(scope.row)">打 印
                </el-button>
            

      </template>
    </avue-crud>
    
  </basic-container>
</template>

<script>
  import { getList, remove,} from "@/api/crmedical/examine/examinereportrectify";
  import {mapGetters} from "vuex";
  import {getProjectList} from "@/api/crmedical/project/project";
  import vUpload from "@/views/components/v-upload";
  import Form from "./examinereportrectify-form.vue";
  import { setStore } from '@/util/store';
  import urlSettings from '@/config/url-settings.js';
  export default {
    components:{
      vUpload,Form
    },
    data() {
      return {
        search:{},
        resultDialog:false,//整改通知弹窗
        printDialog:false,//打印弹窗
        resultForm:{
          attachList:[],
        },
        printForm:{},//打印内容
        form: {},
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        selectionList: [],
        reWrite: false,
        tempProjectId: '',
        projectList:[],
        option: {
          height: 'auto',
          calcHeight: 30,
          tip: false,
          searchShow: true,
          searchMenuSpan: 6,
          selection:false,
          border: true,
          index: true,
          align:"left",
          dialogClickModal: false,
          columnBtn:true,
          addBtn:false,
          viewBtn:false,
          editBtn:false,
          delBtn:false,
          stripe:true,
          column: [
            {
              label: "项目名称",
              prop: "projectId",
              type: 'tree',
              cascaderItem: ['objectType'],
              searchClearable:false,
              editDisabled:true,
              search: true,
              dicUrl: '/api/v4ward/project/getProjectList',
              props: { label: 'name', value: 'id' },
              rules: [{
                required: true,
                message: "请选择项目名称",
                trigger: "change"
              }]
            },
            {
              label: "任务名称",
              prop: "taskName",
              
            },
            {
              label: "整改对象",
              prop: "objectType",
              type: "select",
              search: true,
              showColumn:false,
              searchPlaceholder:"请选择 整改对象",
              dataType: 'string',
              hide:true,
              dicUrl: "/api/v4ward/projectDict/dictionary?code=project_examine_service_type&projectId={{key}}",
              props: {
                label: "dictValue",
                value: "dictKey",
              },
             
            },
            {
              label: "整改对象",
              prop: "rectifyObjectName",
            },
            {
              label: "责任人",
              prop: "responsibles",
              overHidden:true
            },
            {
              label: "合同名称",
              prop: "contractName",
            },
            {
              label: "合同编号",
              prop: "contractCode",
            },
            {
              label: "要求完成日期",
              prop: "requiredEndDate",
              type: "date",
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
            },
            {
              label: "整改进度",
              prop: "degreeStatus",
              dataType:'string',
              searchPlaceholder:"请选择 整改进度",
              dicUrl:"/api/blade-system/dict/dictionary?code=examine_rectify_degree_status",
              props:{
                label:"dictValue",
                value:"dictKey"
              },
              type:"select",
              search:true,
            },
            {
              label: "验收人",
              prop: "acceptors",
            },
            {
              label: "验收日期",
              prop: "acceptDate",
            },
            {
              label: "创建时间",
              prop: "createTime",
              type: "date",
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
            },
            

          ]
        },
        data: []
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.examinereportrectify_add, false),
          viewBtn: this.vaildData(this.permission.examinereportrectify_view, false),
          delBtn: this.vaildData(this.permission.examinereportrectify_delete, false),
          editBtn: this.vaildData(this.permission.examinereportrectify_edit, false)
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    mounted(){
      this.option.height = this.bodyHeight - 338;
      window.onresize = ()=>{
            console.log(this.$refs.crud.$refs.table.doLayout());
}
    },
    created() {
      
      //加载列表
      getProjectList({}).then((res) => {
            this.projectList = res.data;
            this.findObject(
                  this.option.column,
                  'projectId'
                ).dicData = this.projectList;
            setStore({
              name: 'projectList',
              content: this.projectList
            })
            setStore({
              name: 'firstProject',
              content: this.projectList[0]?this.projectList[0].id:""
            })
        if (this.projectList.length > 0) {
          this.query.projectId = this.projectList[0].id;
          this.search.projectId = this.projectList[0].id;
          this.tempProjectId = this.projectList[0].id;
        }
        this.$nextTick(() => {
          this.reWrite = true;
          setTimeout(()=>{
            this.$refs.crud.$children[1].$children[3].$el.addEventListener("click", ()=>{
                  if(this.option.height == this.bodyHeight - 338){
                    this.option.height = this.bodyHeight - 283
                  }else{
                    this.option.height = this.bodyHeight - 338;
                  }
                  this.$refs.crud.getTableHeight();
              });
            })
        });
        
      });
    },
    methods: {
          // 打印
          openPrintDialog(row){
            let path = urlSettings.VUE_APP_BASE_REPORT_URL + urlSettings.VUE_APP_ENVIRONMENT + '/rectification_notice.cpt&op=write'
              +'&id='+row.id
            // path = 'http://192.168.99.202:8075/WebReport/ReportServer?reportlet=rectification_notice.cpt' +'&id='+row.id
            window.open(
              path,
              'newindow',
              'height=600,width=1100,top=100,left=100,toolbar=no,' +
                'menubar=no,scrollbars=no,resizable=no,location=no,status=no,z-look=yes'
            );
          },
          // 查看
          handleOpenFormDialog(row,type){
            this.$refs.form.openDialog(type,row)
          },
          rowDel(row) {
            this.$confirm("确定将选择数据删除?", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
              .then(() => {
                return remove({ids: row.id});
              })
              .then(() => {
                this.onLoad();
                this.$message.success('操作成功!');
              });
          },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
     

      searchReset() {
            this.search.objectType = "";
            this.search.degreeStatus = "";
            this.query.objectType = "";
            this.query.degreeStatus = "";
            this.search.projectId = this.tempProjectId
            this.query.projectId = this.tempProjectId;
            
            this.onLoad();
      },
      searchChange(params, done) {
        this.query = params;
        this.tempProjectId = this.query.projectId;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        //如果加载列表时propertyParentId为空，则将propertyParentId置为当前的第一个房产小区
        if (!this.query.projectId ) {
          this.query.projectId = this.tempProjectId;
        }
        getList(
          Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
        ).then(({data}) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
         
        });
      }
    },
    
    
  };
</script>
<style lang="scss">
.examinereportrectify202111121{
  .avue-form__menu--center{
    text-align: right;
  }
  .avue-crud__search .el-form-item--small.el-form-item{
    width: 100%;
  }
}
#examinereportrectify202111121 > div > div > div > form > div > div.el-table__body-wrapper.is-scrolling-none > table > tbody > tr > td.el-table_2_column_6.is-left > div > div > div {
  color: #f00;
}
</style>


